<template>
  <div class="fdle-wrap">

    <!-- Loading -->
    <div class="state-box" v-if="loadingData">
      <i class="fa fa-spinner fa-spin"></i> Loading…
    </div>

    <!-- Empty -->
    <div class="state-box" v-else-if="!loadingData && table_datas.length === 0">
      <i class="fa fa-map-marker-alt"></i> No Florida ORI rates found
    </div>

    <template v-else>
      <!-- Toolbar -->
      <div class="toolbar">
        <div class="toolbar-left">
          <span class="stat-chip blue">{{ table_datas.length }} ORI entries</span>
        </div>
        <button class="btn-refresh" @click="Refresh()">
          <i class="fa fa-sync-alt"></i> Refresh
        </button>
      </div>

      <!-- Rate table -->
      <div class="table-scroll">
        <div class="list-header">
          <div>ORI</div>
          <div class="col-num">Cost</div>
          <div class="col-num">Def. Markup</div>
          <div class="col-num">Def. Comm.</div>
          <div class="col-num">Def. Tax</div>
          <div class="col-num">Markup</div>
          <div class="col-num">Commission</div>
          <div class="col-num">Tax</div>
          <div class="col-num">Sub Total</div>
          <div class="col-num">Sell Price</div>
          <div class="col-center">Status</div>
        </div>

        <!-- ORI rows -->
        <div
          v-for="(data, index) in table_datas"
          :key="index"
          class="ori-row"
        >
          <div class="orh-name">
            <div class="ori-icon"><i class="fa fa-map-marker-alt"></i></div>
            <span class="ori-code">{{ data.service_ori }}</span>
          </div>
          <div class="orh-val">${{ data.cost || '—' }}</div>
          <div class="orh-val">${{ data.default_markup || '—' }}</div>
          <div class="orh-val">${{ data.default_commission || '—' }}</div>
          <div class="orh-val">{{ data.default_tax || '—' }}%</div>
          <div class="cell-input">
            <div class="input-wrap">
              <span class="ip">$</span>
              <input
                class="rate-input"
                type="number" min="0"
                v-model="data.markup"
                @keyup="changemarkup(index)"
                placeholder="0.00"
              />
            </div>
          </div>
          <div class="cell-input">
            <div class="input-wrap">
              <span class="ip">$</span>
              <input
                class="rate-input"
                type="number" min="0"
                v-model="data.commission_percentage"
                @keyup="changecommission(index)"
                placeholder="0.00"
              />
            </div>
          </div>
          <div class="cell-input">
            <div class="input-wrap">
              <span class="ip">%</span>
              <input
                class="rate-input"
                type="number" min="0"
                v-model="data.tax_percentage"
                @keyup="changetaxpercentage(index)"
                placeholder="0"
              />
            </div>
          </div>
          <div class="orh-val col-subtotal">${{ data.sub_total || '—' }}</div>
          <div class="orh-val orh-sell">${{ data.selling_price || '—' }}</div>
          <div class="col-center">
            <span v-if="hasCustom(data)" class="status-badge s-custom">
              <i class="fa fa-check-circle"></i> Custom
            </span>
            <span v-else class="status-badge s-default">Default</span>
          </div>
        </div>
      </div>
    </template>

    <!-- Save bar -->
    <div class="save-bar" v-if="!loadingData && table_datas.length > 0">
      <div class="save-bar__inner">
        <span class="save-bar__info">
          {{ client.name ? client.name + ' — Florida ORI Rates' : 'Florida ORI Rates' }}
        </span>
        <button class="btn-save" ref="kt_save_service" @click="update('S', 'kt_save_service')">
          <i class="fa fa-check"></i> Save Rates
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import {
  FETCH_LOCATION_ORI_RATE_LISTS,
  UPDATE_LOCATION_ORI_RATE_LISTS
} from "@/core/services/store/actions.type";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Locations", route: "client.location" },
        { id: 3, title: "Update Rate", route: "" }
      ],
      table_datas: [],
      errors: [],
      loadingData: false,
      serviceError: "",
      selectAll: false,
      service_ori: [],
      rates: [],
      client: [],
      set_default_markup: "",
      set_default_commission: "",
      set_default_tax: ""
    };
  },
  computed: {
    ...mapGetters(["getServiceOriData"])
  },
  created() {
    this.breadCrumbs[2].title = "Edit Rate";
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    this.getServiceData();
  },
  methods: {
    hasCustom(data) {
      return data.markup || data.tax_percentage || data.commission_percentage;
    },
    closeBtnLoad(ref) {
      const b = this.$refs[ref];
      if (b) { b.classList.remove("spinner","spinner-light","spinner-right"); b.disabled = false; }
    },
    loadingButton(ref) {
      const b = this.$refs[ref];
      if (b) { b.disabled = true; b.classList.add("spinner","spinner-light","spinner-right"); }
    },
    getServiceData() {
      this.loadingData = true;
      this.table_datas = [];
      const data_ = { id: this.$route.params.id, code: "fdle" };
      this.$store.dispatch(FETCH_LOCATION_ORI_RATE_LISTS, data_)
        .then(data => {
          this.rates = data.rates;
          this.client = data.client;
          this.set_default_markup    = data.client.default_markup;
          this.set_default_tax       = data.client.default_tax;
          this.set_default_commission = data.client.default_commission;
          this.rates.forEach(service_ori => {
            const base = {
              id: service_ori.id,
              service_ori: service_ori.ori_number,
              checked: !!service_ori.location_service_ori_id,
              cost: service_ori.cost,
              default_markup:     service_ori.default_ori_markup             ?? "",
              default_commission: service_ori.default_ori_commission_percentage ?? "",
              default_tax:        service_ori.default_ori_tax_percentage      ?? "",
              markup:             service_ori.markup                          ?? "",
              sub_total:          service_ori.sub_total,
              tax_percentage:     service_ori.location_tax_percentage         ?? "",
              commission_percentage: service_ori.commission_percentage        ?? "",
              selling_price:      service_ori.selling_price
            };
            this.table_datas.push(base);
          });
          this.loadingData = false;
        })
        .catch(() => { this.loadingData = false; });
    },
    _calcTotals(index) {
      const d = this.table_datas[index];
      const cost       = parseFloat(d.cost || 0);
      const markup     = d.markup             ? parseFloat(d.markup)             : parseFloat(d.default_markup     || 0);
      const commission = d.commission_percentage ? parseFloat(d.commission_percentage) : parseFloat(d.default_commission || 0);
      const tax        = d.tax_percentage     ? parseFloat(d.tax_percentage)     : parseFloat(d.default_tax        || 0);
      const sub = cost + markup + commission;
      d.sub_total     = (Math.round(sub * 100) / 100).toFixed(2);
      d.selling_price = (Math.round((sub + sub * tax / 100) * 100) / 100).toFixed(2);
    },
    changemarkup(index)        { this._calcTotals(index); },
    changecommission(index)    { this._calcTotals(index); },
    changetaxpercentage(index) { this._calcTotals(index); },
    Refresh() {
      this.set_default_markup = "";
      this.set_default_tax = "";
      this.set_default_commission = "";
      this.table_datas = [];
      this.getServiceData();
    },
    update(_saveType, ref) {
      this.errors = [];
      this.loadingButton(ref);
      this.$store.dispatch(UPDATE_LOCATION_ORI_RATE_LISTS, {
        location_id:        this.$route.params.id,
        code:               this.client.service_type,
        default_rate:       "",
        default_tax:        "",
        default_commission: "",
        rate_list:          this.table_datas
      })
        .then(data => {
          this.$toastr.s(data.msg);
          this.closeBtnLoad(ref);
          this.getServiceData();
        })
        .catch(err => {
          this.errors = err;
          this.selectAll = false;
          this.serviceError = "";
          this.closeBtnLoad(ref);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$font:    'Segoe UI', sans-serif;
$blue:    #389ad4;
$dark:    #0d1b3e;
$green:   #276749;
$purple:  #6b21a8;
$border:  #dde2ec;

/* ── Toolbar ── */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-bottom: 1px solid #f0f2f8;
  background: #fafbfd;

  .toolbar-left { display: flex; gap: 8px; align-items: center; }

  .stat-chip {
    padding: 3px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;

    &.blue { background: #dbeafe; color: #1d4ed8; }
  }

  .btn-refresh {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    padding: 0 14px;
    background: #fff;
    color: #4a5568;
    border: 1.5px solid $border;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    font-family: $font;
    cursor: pointer;
    transition: all 0.15s;

    &:hover { border-color: $blue; color: $blue; }
  }
}

/* ── Scrollable table ── */
.table-scroll {
  overflow: auto;
  max-height: 60vh;
}

$grid-cols: minmax(160px, 1fr) 70px 90px 100px 70px 120px 120px 120px 90px 90px 90px;

/* ── List header ── */
.list-header {
  display: grid;
  grid-template-columns: $grid-cols;
  align-items: center;
  padding: 8px 20px;
  background: #fafbfd;
  border-bottom: 2px solid #eef0f8;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #a0aab8;
  gap: 8px;
  min-width: max-content;
  position: sticky;
  top: 0;
  z-index: 1;

  .col-num    { text-align: right; }
  .col-center { text-align: center; }
}

/* ── ORI row ── */
.ori-row {
  display: grid;
  grid-template-columns: $grid-cols;
  align-items: center;
  padding: 10px 20px;
  gap: 8px;
  border-bottom: 1px solid #f5f7fa;
  min-width: max-content;

  &:last-child { border-bottom: none; }
  &:hover { background: #f8fbff; }
}

.cell-input { display: flex; justify-content: flex-end; }

.col-center { text-align: center; }

.col-subtotal { color: $purple; }

.orh-name {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;

  .ori-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    background: #ede9fe;
    color: $purple;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    flex-shrink: 0;
  }

  .ori-code {
    font-size: 13px;
    font-weight: 400;
    color: $dark;
    font-family: monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.orh-val {
  text-align: right;
  font-size: 12px;
  font-family: monospace;
  font-weight: 600;
  color: #4a5568;

  &.orh-sell { color: $blue; }
}

/* ── Status badges ── */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 9px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;

  &.s-custom  { background: #dcfce7; color: $green; }
  &.s-default { background: #e2e8f0; color: #718096; }
}

/* ── Input ── */
.input-wrap {
  display: flex;
  align-items: center;
  height: 28px;
  border: 1.5px solid $border;
  border-radius: 6px;
  background: #fff;
  overflow: hidden;
  transition: border-color 0.15s;
  width: 110px;

  &:focus-within { border-color: $blue; box-shadow: 0 0 0 2px rgba(56,154,212,0.1); }

  .ip {
    height: 100%;
    padding: 0 5px 0 7px;
    background: #f5f7fa;
    border-right: 1px solid #e2e8f0;
    color: #a0aab8;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    user-select: none;
  }

  .rate-input {
    flex: 1;
    border: none;
    outline: none;
    height: 100%;
    padding: 0 6px;
    font-size: 12px;
    color: $dark;
    font-family: $font;
    background: transparent;
    text-align: right;
    min-width: 0;

    &[type=number] { -moz-appearance: textfield; appearance: textfield; }
    &::-webkit-outer-spin-button, &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
  }
}

/* ── States ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* ── Save bar ── */
.save-bar {
  position: fixed;
  bottom: 2.5rem;
  width: calc(78vw);
  z-index: 200;

  .save-bar__inner {
    background: $dark;
    border-radius: 12px;
    box-shadow: 0 8px 32px rgba(13,27,62,0.3);
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .save-bar__info {
      font-size: 13px;
      color: rgba(255,255,255,0.75);
      font-family: $font;
    }

    .btn-save {
      display: inline-flex;
      align-items: center;
      gap: 7px;
      height: 36px;
      padding: 0 22px;
      background: $green;
      color: #fff;
      border: none;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
      font-family: $font;
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover { opacity: 0.9; }
      &:disabled { opacity: 0.55; cursor: not-allowed; }
    }
  }
}
</style>
